import Form from "../../../core/forms/form";
import {systems} from "../../../core/data/global";

export const CorporateTransactionInitForm = {
    mixins: [systems],
    data: function () {
        return {
            user: window.user,
            loading: false,
            methods: {
                'ecocash': 'ZWG',
                'stripe': 'USD',
                'ecocash-usd': 'USD',
                'bank-usd': 'USD',
                'bank': 'ZWG',
                'cash': 'USD',
                'wallet': 'ZWG',
                'wallet-usd': 'USD',
            },
            bundles: [], smart: [], netone: [], batch: {},
            form: new Form({
                name: '',
                corporate_name: '',
                corporate_phone: '',
                corporate_email: '',

                payment: '',
                email: window.user.email,
                ecocash: '',
                zesa: [],
                airtimeEco: [],
                airtime: [],
                bundle: [],
                smart: [],
                netone: [],
            })
        };
    },
    computed: {
        isCopiedTransaction() {
            return this.$route.query.copy !== undefined;
        },
        batchTotal() {
            return this.form.zesa.map(e => e.amount).reduce(this.sum, 0)  + this.form.airtimeEco.map(e => e.amount).reduce(this.sum, 0)  + this.form.airtime.map(e => e.amount).reduce(this.sum, 0) + this.form.bundle.map(e => e.amount).reduce(this.sum, 0) + this.form.smart.map(e => e.amount).reduce(this.sum, 0) + this.form.netone.map(e => e.amount).reduce(this.sum, 0)
        }
    },
    methods: {

        ccurrency: function () {
            if (this.methods[this.form.payment] === "ZWG") {
                this.form.smart = [];
                this.form.netone = [];
            }
        },

        sum: function (prev, next) {
            return parseFloat(prev) + parseFloat(next);
        },

        submit: function () {
            this.loading = true;
            this.form
                .submit('/business/csubmit')
                .then((response) => {
                    this.$router.push(`/business/view?ref=${response.data.body.batch.ref}`);
                })
                .finally(() => this.loading = false);
        },

        ccorporte: function () {
            if (this.user.corporate_id !== undefined) {
                window.axios.get(`/business/settings/api`).then((response) => {
                    this.form.corporate_name = response.data.body.model.name;
                    this.form.name = response.data.body.model.contact_name;
                    this.form.corporate_phone = response.data.body.model.contact_phone;
                    this.form.corporate_email = response.data.body.model.contact_email;
                });
            }
        },

        lbundles: function () {
            this.loading = true;

            window.axios
                .get(`/business/lbundles`)
                .then((response) => {

                    this.bundles = response.data.body.bundles;
                    this.smart = response.data.body.smart;
                    this.netone = response.data.body.netone;

                    // Get batch
                    if (this.$route.query.copy) {
                        return window.axios['post'](`${window.location.origin}/business/view`, {
                            ref: this.$route.query.copy
                        })
                    } //else this.addNewFieldRow('all', 0)

                    return Promise.resolve({})
                })
                .then((response) => {
                    if (!(response.data && response.data.success)) return;

                    this.batch = response.data.body.model;
                    let map = {
                        'App\\CashPayment': 'cash',
                        'App\\EcocashPayment': 'ecocash',
                        'App\\StripePayment': 'stripe',
                        'App\\BankPayment': 'bank',
                    };
                    this.form.payment = map[this.batch.payment_type];
                    if (this.form.payment === "ecocash" && this.batch.payment_currency === "USD") {
                        this.form.payment = "ecocash-usd";
                    }
                    if (this.form.payment === "bank" && this.batch.payment_currency === "USD") {
                        this.form.payment = "bank-usd";
                    }
                    this.form.ecocash = this.batch.ecocash ? this.batch.ecocash : '';
                    this.form.email = this.batch.ecocash ? this.batch.email : '';
                    if (this.batch.zesa) {
                        for (const transaction of this.batch.zesa.transactions) {
                            this.form.zesa.push({
                                meter: transaction.meter,
                                phone: transaction.phone,
                                amount: transaction.amount,
                                errors: transaction.errors
                            });
                        }
                    }
                    if (this.batch.airtime) {
                        for (const transaction of this.batch.airtime.transactions) {
                            this.form.airtime.push({
                                phone: transaction.phone, amount: transaction.amount, errors: transaction.errors
                            });
                        }
                    }
                    if (this.batch.airtimeEco) {
                        for (const transaction of this.batch.airtimeEco.transactions) {
                            this.form.airtimeEco.push({
                                phone: transaction.phone, amount: transaction.amount, errors: transaction.errors
                            });
                        }
                    }
                    if (this.batch.bundle) {
                        for (const transaction of this.batch.bundle.transactions) {
                            this.form.bundle.push({
                                phone: transaction.phone,
                                bundle: transaction.bundle_id,
                                amount: transaction.amount,
                                errors: transaction.errors
                            });

                            this.gbundle('bundle', this.form.bundle.length - 1);
                        }
                    }
                    if (this.batch.smart) {
                        for (const transaction of this.batch.smart.transactions) {
                            this.form.smart.push({
                                phone: transaction.phone,
                                bundle: transaction.bundle_id,
                                amount: transaction.amount,
                                errors: transaction.errors
                            });

                            this.gbundle('smart', this.form.smart.length - 1);
                        }
                    }
                    if (this.batch.netone) {
                        for (const transaction of this.batch.netone.transactions) {
                            this.form.netone.push({
                                phone: transaction.phone,
                                bundle: transaction.bundle_id,
                                amount: transaction.amount,
                                errors: transaction.errors
                            });

                            this.gbundle('netone', this.form.netone.length - 1);
                        }
                    }
                })
                .finally(() => this.loading = false);
        },

        copy: function (item, index, fields) {
            let a = {};
            for (let i = 0; i < fields.length; i++) {
                a[fields[i]] = this.form[item][index][fields[i]];
            }
            this.form[item].push(a);
        },

        remove: function (item, index) {
            this.form[item].splice(index, 1);
        },

        gbundle: function (item, index) {
            let key = (item === "smart" || item === "netone") ? item : 'bundles';

            if (this[key].filter((e) => e.id === this.form[item][index].bundle).length > 0) {
                this.form[item][index].amount = this[key].filter((e) => e.id === this.form[item][index].bundle)[0].price;
            }
        },

        addNewFieldRow: function (source, index) {
            if (source !== 'all') {
                const lastItemIndex = this.form[source].length - 1;
                if (lastItemIndex >= index) return;
            }

            if (['zesa', 'all'].includes(source)) {
                this.form['zesa'].push({meter: '', phone: '', amount: ''});
            }

            if (['airtime', 'all'].includes(source)) {
                this.form['airtime'].push({phone: '', amount: ''});
            }

            if (['airtimeEco', 'all'].includes(source)) {
                this.form['airtimeEco'].push({phone: '', amount: ''});
            }

            if (['bundle', 'all'].includes(source)) {
                this.form['bundle'].push({phone: '', bundle: '', amount: ''});
            }

            if (['smart', 'all'].includes(source)) {
                this.form['smart'].push({phone: '', bundle: '', amount: ''});
            }

            if (['netone', 'all'].includes(source)) {
                this.form['netone'].push({phone: '', bundle: '', amount: ''});
            }
        },

        mapAmount(e) {
            const amount = parseFloat(e.amount);
            return isNaN(amount) ? 0 : amount;
        },
    },
    mounted() {
        if (localStorage.getItem('loadedOnce') === "true") {
            localStorage.setItem('loadedOnce', false);
        }
        this.ccorporte();
        this.form.payment = 'wallet-usd';
        this.lbundles();
    }
}
